import Button from '@/framework/base/classes/Button';
import {MapRessource} from '@/framework/base/helpers/Ressources';
import {Sections} from '@/generated/classes/AppSchema';
import {ObjTypes} from '@/generated/classes/ObjTypes';
import Fiche from './Fiche';
import AdminInfo from '@/generated/classes/AdminInfo';
import Owner from '@/generated/classes/Owner';


export default class Section {
    // eslint-disable-next-line
    public component: any;
    public ressource: MapRessource;
    public objType: ObjTypes;
    public objId: number;
    public type: string;
    // eslint-disable-next-line
    public data: any;
    public propType: string;
    // eslint-disable-next-line
    public propData: any;
    public picto: string;
    public autoClear: boolean;
    public showButton: boolean;
    public contextId: number;
    public buttons: Button[];
    public chat: boolean;
    public autoSave: boolean;
    public unreadChatCount: number;
    public chatLabel: string;
    public sectionName: Sections;
    public fullscreen: boolean;
    public helper: boolean;
    public adminInfo: AdminInfo;
    public owner: Owner;
    public requiredAttributs: string[];
}


export class RouteElements {
    public section: Section;
    public fiche: Fiche;
}
